import React, { Component, PureComponent, Fragment } from 'react'
import { Field, Submit, Group, Info, InfoGroup } from '~/form'
import { Map, List, fromJS } from 'immutable'
import { DeletePrompt } from '~/datatable/views/edit'

export default class MessageTemplateEdit extends Component {
  render() {
    let { config, configLoading, formUpdate, formSubmit, formState, formLoading, onCancel, dataId, itemId } = this.props

    let { values } = formState
    let rawEdit = values.getIn([itemId, 'data', 'rawEdit'], false)

    let fields = config.get('formFields', List()).filter(f => f.get('name') !== 'templates')

    return (
      <Fragment>
        <div className="datatable-action-content">
          {fields
            .toJS()
            .map(
              ({
                label,
                inputLabel,
                type,
                name,
                options = [],
                referenceConfig = {},
                multiple = false,
                placeholder = '',
                ...inputProps
              }) => {
                return (
                  <Field
                    {...inputProps}
                    label={label}
                    inputLabel={inputLabel}
                    type={type}
                    name={itemId + '.' + name}
                    options={options}
                    multiple={multiple}
                    referenceConfig={referenceConfig}
                    key={itemId + '.' + name}
                    onChange={formUpdate}
                    placeholder={placeholder}
                    disabled={name === dataId}
                    formState={formState}
                  />
                )
              }
            )}
          <Field
            inputLabel="Käytä koodieditoria"
            type="checkbox"
            name={itemId + '.data.rawEdit'}
            onChange={formUpdate}
            formState={formState}
          />
          <Field
            type="templates"
            rawEdit={rawEdit}
            name={itemId + '.templates'}
            onChange={formUpdate}
            formState={formState}
          />
        </div>
        <div className="datatable-action-buttons datatable-action-buttons--flex">
          <div>
            <Submit content="Tallenna" icon="save" color="green" />
            <button className="datatable-action-button-cancel" onClick={e => e.preventDefault() & onCancel()}>
              Sulje
            </button>
          </div>
          <div>
            <DeletePrompt onAnswer={answer => (answer ? formSubmit({ isDelete: true }) : null)} />
          </div>
        </div>
      </Fragment>
    )
  }
}
